<span
  class="ws-button-tooltip-host"
  [wsTooltip]="effectiveTooltip"
  [wsTooltipDisabled]="!effectiveTooltip"
>
  <button
    mat-stroked-button
    [dwsPermission]="permission"
    dwsPermissionDenyMode="disable"
    (click)="disabled ? $event.stopPropagation() : onClick($event)"
    [ngStyle]="{
      color: textColor,
      'background-color': backgroundColor,
      'border-color': backgroundColor,
      'width': width ? width : 'auto'
    }"
    [disabled]="disabled"
    [ngClass]="{
     'isCallToAction': isCallToAction,
     'colorPrimary': callToActionType === 'primary',
     'colorSecondary': callToActionType === 'secondary',
     'colorTertiary': callToActionType === 'tertiary',
     'colorDanger': callToActionType === 'danger',
     'colorWarning': callToActionType === 'warning',
     'colorSuccess': callToActionType === 'success',
     'colorInfo': callToActionType === 'info',
     'colorLink': callToActionType === 'link'
    }"
  >
    <ng-content></ng-content>
  </button>
</span>